import {lazy} from 'react';
import PanelPaths from "../paths/panel";

const PanelRoutes = [
    {
        path: PanelPaths.dashboard,
        component: lazy(() => import('@src/views/panel/dashboard')),
        auth: true
    },
    // Admin
    {
        path: PanelPaths.admin.articlesCategories,
        component: lazy(() => import('@src/views/panel/articlesCategories')),
        auth: true
    },
    {
        path: PanelPaths.admin.articlesList,
        component: lazy(() => import('@src/views/panel/articles')),
        auth: true
    },
    {
        path: PanelPaths.admin.servicesList,
        component: lazy(() => import('@src/views/panel/services')),
        auth: true
    },
    {
        path: PanelPaths.admin.catalogsList,
        component: lazy(() => import('@src/views/panel/catalog')),
        auth: true
    },
    {
        path: PanelPaths.admin.productsFeatures,
        component: lazy(() => import('@src/views/panel/features')),
        auth: true
    },

    {
        path: PanelPaths.admin.productsCategories,
        component: lazy(() => import('@src/views/panel/productsCategories')),
        auth: true
    },
    {
        path: PanelPaths.admin.productsList,
        component: lazy(() => import('@src/views/panel/products')),
        auth: true
    },
    {
        path: PanelPaths.admin.productsFeatureGroups + "/:productId",
        component: lazy(() => import('@src/views/panel/products/featureGroups')),
        auth: true
    },
    {
        path: PanelPaths.admin.wareHouse,
        component: lazy(() => import('@src/views/panel/warehouse')),
        auth: true
    },
    {
        path: PanelPaths.admin.productsAttributeGroups + "/:productId",
        component: lazy(() => import('@src/views/panel/products/attributeGroups')),
        auth: true
    },
    {
        path: PanelPaths.admin.websiteSliders,
        component: lazy(() => import('@src/views/panel/sliders')),
        auth: true
    },
    {
        path: PanelPaths.admin.websiteCatalogue,
        component: lazy(() => import('@src/views/panel/catalogue')),
        auth: true
    },
    {
        path: PanelPaths.admin.websiteGallery,
        component: lazy(() => import('@src/views/panel/gallery')),
        auth: true
    },
    {
        path: PanelPaths.admin.websiteBusinessGallery,
        component: lazy(() => import('@src/views/panel/businessGallery')),
        auth: true
    },
    {
        path: PanelPaths.admin.websiteBanners,
        component: lazy(() => import('@src/views/panel/homeBanner')),
        auth: true
    },
    {
        path: PanelPaths.admin.websiteProductCategoryBanners,
        component: lazy(() => import('@src/views/panel/banners/productCategories')),
        auth: true
    },
    {
        path: PanelPaths.admin.websiteFaq,
        component: lazy(() => import('@src/views/panel/faq')),
        auth: true
    },
    {
        path: PanelPaths.admin.websiteStories,
        component: lazy(() => import('@src/views/panel/stories')),
        auth: true
    },
    {
        path: PanelPaths.admin.websiteGuide,
        component: lazy(() => import('@src/views/panel/guide')),
        auth: true
    },
    {
        path: PanelPaths.admin.websiteMenu,
        component: lazy(() => import('@src/views/panel/menu')),
        auth: true
    },
    {
        path: PanelPaths.admin.websiteSettings,
        component: lazy(() => import('@src/views/panel/settings')),
        auth: true
    },
    {
        path: PanelPaths.admin.mediaImages,
        component: lazy(() => import('@src/views/panel/mediaImages')),
        auth: true
    },
    {
        path: PanelPaths.admin.adminSmsSetting,
        component: lazy(() => import('@src/views/panel/smsSetting/admin')),
        auth: true
    },
    {
        path: PanelPaths.admin.customerSmsSetting,
        component: lazy(() => import('@src/views/panel/smsSetting/customer')),
        auth: true
    },
    {
        path: PanelPaths.admin.roles,
        component: lazy(() => import('@src/views/panel/userRoles')),
        auth: true
    },
    {
        path: PanelPaths.admin.customers,
        component: lazy(() => import('@src/views/panel/userCustomers')),
        auth: true
    },
    {
        path: PanelPaths.admin.personnel,
        component: lazy(() => import('@src/views/panel/userPersonnel')),
        auth: true
    },
    {
        path: PanelPaths.admin.coWorker,
        component: lazy(() => import('@src/views/panel/userCoWorker')),
        auth: true
    }, {
        path: PanelPaths.admin.showOrder + "/:orderId",
        component: lazy(() => import('@src/views/panel/orders/admin/OrderPage')),
        auth: true
    }, {
        path: PanelPaths.customer.showOrder + "/:orderId",
        component: lazy(() => import('@src/views/panel/orders/customer/OrderPage')),
        auth: true
    },
    {
        path: PanelPaths.admin.invoices,
        component: lazy(() => import('@src/views/panel/invoices')),
        auth: true
    }, {
        path: PanelPaths.admin.invoices + "/:orderId",
        component: lazy(() => import('@src/views/panel/orderInvoiceManagement')),
        auth: true
    },
    {
        path: PanelPaths.admin.coupons,
        component: lazy(() => import('@src/views/panel/coupons')),
        auth: true
    },
    {
        path: PanelPaths.admin.productGroupOffer,
        component: lazy(() => import('@src/views/panel/groupOffer')),
        auth: true
    },
    {
        path: PanelPaths.admin.customerBrand,
        component: lazy(() => import('@src/views/panel/customerBrand')),
        auth: true
    },
    {
        path: PanelPaths.admin.brand,
        component: lazy(() => import('@src/views/panel/brand')),
        auth: true
    },    {
        path: PanelPaths.admin.grading,
        component: lazy(() => import('@src/views/panel/grading')),
        auth: true
    },
    {
        path: PanelPaths.admin.tags,
        component: lazy(() => import('@src/views/panel/tag')),
        auth: true
    },
    {
        path: PanelPaths.admin.commercialPartners,
        component: lazy(() => import('@src/views/panel/commercialPartners')),
        auth: true
    },
    {
        path: PanelPaths.comments,
        component: lazy(() => import('@src/views/panel/comments')),
        auth: true
    },
    {
        path: `${PanelPaths.label()}/:id`,
        component: lazy(() => import('@src/views/panel/label')),
        layout: 'EmptyLayout',
        auth: true
    },
    {
        path: `${PanelPaths.invoice()}/:id`,
        component: lazy(() => import('@src/views/panel/invoice')),
        layout: 'EmptyLayout',
        auth: true
    },
    // Customer Panel
    {
        path: PanelPaths.customer.favorite,
        component: lazy(() => import('@src/views/panel/customerFavorite')),
        auth: true
    },
    {
        path: PanelPaths.orders,
        component: lazy(() => import('@src/views/panel/orders')),
        auth: true
    },
    {
        path: PanelPaths.customer.invoices,
        component: lazy(() => import('@src/views/panel/customerInvoices')),
        auth: true
    },
    {
        path: PanelPaths.customer.addresses,
        component: lazy(() => import('@src/views/panel/customerAddresses')),
        auth: true
    },
    {
        path: PanelPaths.userAccount,
        component: lazy(() => import('@src/views/panel/account')),
        auth: true
    },
    {
        path: PanelPaths.admin.contactRequests,
        component: lazy(() => import('@src/views/panel/contactsRequests')),
        auth: true
    },
    {
        path: PanelPaths.admin.ReservationRequest,
        component: lazy(() => import('@src/views/panel/ReservationRequest')),
        auth: true
    },
    {
        path: PanelPaths.admin.deliveryMethods,
        component: lazy(() => import('@src/views/panel/deliveryMethods')),
        auth: true
    },
    {
        path: PanelPaths.admin.logs,
        component: lazy(() => import('@src/views/panel/logs')),
        auth: true
    },
    {
        path: PanelPaths.seo.redirects,
        component: lazy(() => import('@src/views/panel/redirects')),
        auth: true
    }, {
        path: PanelPaths.seo.pages,
        component: lazy(() => import('@src/views/panel/SeoPages')),
        auth: true
    },
    {
        path: PanelPaths.admin.transaction,
        component: lazy(() => import('@src/views/panel/transaction')),
        auth: true
    },
    {
        path: PanelPaths.admin.fieldMaker.fields,
        component: lazy(() => import('@src/views/panel/fieldMaker/fields')),
        auth: true
    },
    {
        path: `${PanelPaths.admin.fieldMaker.options}/:fieldId`,
        component: lazy(() => import('@src/views/panel/fieldMaker/options')),
        auth: true
    },
    {
        path: PanelPaths.admin.variables,
        component: lazy(() => import('@src/views/panel/variables')),
        auth: true
    },
    {
        path: PanelPaths.admin.serviceCategories,
        component: lazy(() => import('@src/views/panel/serviceCategories')),
        auth: true
    },
    {
        path: PanelPaths.admin.catalogCategories,
        component: lazy(() => import('@src/views/panel/catalogCategories')),
        auth: true
    },
    {
        path: PanelPaths.admin.attribute(),
        component: lazy(() => import('@src/views/panel/attribute')),
        auth: true
    },
    {
        path: `${PanelPaths.admin.attribute()}/:id`,
        component: lazy(() => import('@src/views/panel/attribute/components/options')),
        auth: true
    },

    // customer club route
    {
        path: PanelPaths.admin.customerClub.clubs,
        component: lazy(() => import('@src/views/panel/customerClub/clubs')),
        auth: true
    },
    {
        path: PanelPaths.admin.customerClub.rating,
        component: lazy(() => import('@src/views/panel/customerClub/rating')),
        auth: true
    },
    {
        path: PanelPaths.admin.customerClub.event,
        component: lazy(() => import('@src/views/panel/customerClub/event')),
        auth: true
    },

]

export default PanelRoutes
